import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function FalcoBorn() {
  const dateTexts = ['1801年'];
  const title = 'カメリアファルコ誕生';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2021/12/camellia_01.jpg'
  const description = (
    <>
      <a href='/camellia-falco'>
        {'カメリアファルコ'}
      </a>
      {'は、ファンタスティック・フライト・ミュージアム初代館長であるチェッリーノ・ファルコの娘として誕生する。'}
      {'幼少期から空を飛ぶことに興味を持ち、生涯をかけて飛行の研究に情熱を燃やす。'}
    </>
  );
  const quoteDomain = 'Disney';

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default FalcoBorn;
